import { Environment, ServerConfig } from "@mimber/schema"

const serverConfig: { [key in Environment]: ServerConfig } = {
  development: {
    domain: "https://api-dev.mimber.com/",
  },
  local: {
    domain: "http://localhost:3001/",
  },
  production: {
    domain: "https://api.mimber.com/",
  },
  staging: {
    domain: "https://api-staging.mimber.com/",
  },
}

export default serverConfig
